import { IWeeklyTargetWidgetRequest } from '../../interfaces/dashboard-weekly-target.interface'
import {
  IDashboardWidgetRequest,
  IDashboardWidgetTimeRequest
} from '../../interfaces/dashboard-widget.interface'
import { IWeekOverWeekRequest } from '../../interfaces/dashboard-week-over-week.interface'

export class GetTireWidgetInfo {
  static readonly type = '[Dashboards] Get Tire Widget Info'
  constructor(public payload: IDashboardWidgetTimeRequest) {}
}

export class GetWeeklyTargetWidgetInfo {
  static readonly type = '[Dashboards] Get Weekly Target Widget Info'
  constructor(public payload: IWeeklyTargetWidgetRequest) {}
}

export class GetContactsTypeWidgetInfo {
  static readonly type = '[Dashboards] Get Contacts Type Widget Info'
  constructor(public payload: IDashboardWidgetTimeRequest) {}
}

export class GetArReceivablesWidgetInfo {
  static readonly type = '[Dashboards] Get Ar Receivables Widget Info'
  constructor(public payload: IDashboardWidgetTimeRequest) {}
}

export class GetReceivablesWidgetInfo {
  static readonly type = '[Dashboards] Get Receivables Widget Info'
  constructor(public payload: IDashboardWidgetRequest) {}
}

export class GetScheduleWeeks {
  static readonly type = '[Dashboards] Get Schedule Weeks'
}

export class GetWeekOverWeek {
  static readonly type = '[Dashboards] Get Week Over Week'
  constructor(public payload: IWeekOverWeekRequest) {}
}
